import React from 'react';
import { Page, Content, BackBtn, BtnPrimary, ProductDetailGrid } from './styled';

export default React.memo(function ProductDetailView({ product, onBack, onBuy }) {
  if (!product) return null;
  const image = product.pictures?.[0];
  const name = product.title || 'Product';
  const price = product.product_sizes_quantity?.[0]?.price ?? product.euro_price?.[0] ?? 0;
  const symbol = product.symbol || 'USDT';

  return (
    <Page>
      <Content style={{ paddingTop: '2.5rem' }}>
        <BackBtn type="button" onClick={onBack}>
          ← Back to Store
        </BackBtn>
        <ProductDetailGrid>
          {image && (
            <img
              src={image}
              alt={name}
              style={{ borderRadius: '0.75rem', width: '100%', objectFit: 'cover' }}
            />
          )}
          <div>
            <h1 style={{ fontSize: '1.875rem', fontWeight: 600, margin: '0 0 1.5rem 0' }}>
              {name}
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1.5rem' }}>
              <span style={{ fontSize: '1.25rem' }}>
                {price} {symbol}
              </span>
              {onBuy && (
                <BtnPrimary type="button" onClick={() => onBuy(product)}>
                  Buy Now
                </BtnPrimary>
              )}
            </div>
          </div>
        </ProductDetailGrid>
      </Content>
    </Page>
  );
});
